import type { TranslateWrapperProps } from "interfaces/shared.types";
import React from "react";

type HighlightTextProps = {
  highlightTag: string;
  text: string | { props: TranslateWrapperProps };
  symbolsToHighlight: string | string[];
  className: string;
};

export const HighlightText = ({
  highlightTag = "b",
  text,
  symbolsToHighlight,
  className = "",
}: HighlightTextProps) => {
  const renderHighlighted = (str: string) => {
    const parts = str.split(/(<mark>.*?<\/mark>)/g);
    return parts.map((part, i) => {
      const match = part.match(/^<mark>(.*?)<\/mark>$/);
      return match ? <mark key={i}>{match[1]}</mark> : part;
    });
  };
  const searchPattern = Array.isArray(symbolsToHighlight)
    ? symbolsToHighlight.filter(Boolean).join("|")
    : symbolsToHighlight;
  const regExSearchedString = new RegExp(searchPattern, "ig");
  const highlightedStr =
    typeof text === "object"
      ? text.props.text?.replace(
          regExSearchedString,
          (overlap) => `<${highlightTag}>${overlap}</${highlightTag}>`,
        )
      : text.replace(
          regExSearchedString,
          (overlap) => `<${highlightTag}>${overlap}</${highlightTag}>`,
        );

  return (
    <span className={className}>{renderHighlighted(highlightedStr ?? "")}</span>
  );
};
